import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AccountLifetimeAllowanceDispatcher } from "./Variable";


export interface AccountLifetimeAllowanceState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
    lifetimeAllowanceOffPlatform?: number; //todo
    onPlatformData?: any;
}

export class AccountLifetimeAllowanceStatic extends BaseStore<AccountLifetimeAllowanceState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AccountLifetimeAllowanceDispatcher, (actionData) => this.onAccountLifetimeAllowanceStoreResponse(actionData));
    }

    public getLastResult(): AccountLifetimeAllowanceState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getLifetimeAllowanceOffPlatform() {   //todo
        return this.getState().lifetimeAllowanceOffPlatform;
    }
   
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AccountLifetimeAllowanceState {
        return { actionType: ActionType.Loading, data: null, };
    }

    private onAccountLifetimeAllowanceStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:  //todo
                    this.setState({ actionType: actionData.actionType, lifetimeAllowanceOffPlatform: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
